import { render, staticRenderFns } from "./PureModeCourseCpnt.vue?vue&type=template&id=465b5aec&scoped=true&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeCourseCpnt/PureModeCourseCpnt/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeCourseCpnt/PureModeCourseCpnt/index.js?vue&type=script&lang=js&"
import style0 from "./PureModeCourseCpnt.vue?vue&type=style&index=0&id=465b5aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465b5aec",
  null
  
)

export default component.exports